import { router, Tabs } from 'expo-router'
import type { ComponentProps } from 'react'
import { View } from 'react-native'
import { TopTabBar, useIsTabBarPositionedTop } from '@/src/common/components/TopTabBar'
import { BottomTabBar } from '@react-navigation/bottom-tabs'
import { useDismissToCardHome } from '@/src/app/main/(tabs)/card'
import { mesaColorNames } from '@/src/common/theme'
import { tabsList } from '@/src/experiences/tabs'
import { withCardGate } from '@/src/experiences/card-accounts/withCardGate'
import * as Branding from '@/src/experiences/branding'

export default withCardGate(function TabLayout({ showCardManagement, firstCardFetchFinished }) {
  const isTabBarPositionedTop = useIsTabBarPositionedTop()
  const dismissToCardHome = useDismissToCardHome({ showCardManagement, firstCardFetchFinished })
  const { colorValue: primaryColor } = Branding.Hooks.usePrimaryColor()

  return (
    <View style={{ flex: 1 }}>
      <Tabs
        tabBar={
          isTabBarPositionedTop
            ? (props) => (
                <TopTabBar>
                  <BottomTabBar {...props} />
                </TopTabBar>
              )
            : undefined
        }
        screenOptions={{
          headerShown: false,
          tabBarPosition: isTabBarPositionedTop ? 'top' : 'bottom',
          tabBarStyle: isTabBarPositionedTop ? { borderBottomWidth: 0, flexBasis: 555 } : undefined,
        }}
      >
        {tabsList.map(({ title, name, Icon, options }) => (
          <Tabs.Screen
            listeners={{
              tabPress() {
                name === 'card' ? dismissToCardHome() : router.dismissTo(`/main/${name}`)
              },
            }}
            key={name}
            name={name}
            options={{
              tabBarButtonTestID: `navigate_to_tab_${name}`,
              title,
              tabBarActiveTintColor: primaryColor,
              headerShadowVisible: false,
              tabBarIcon: ({ focused }) => (
                <Icon
                  svgProps={{ width: 32, height: 32 }}
                  outlineColor={focused ? primaryColor : mesaColorNames['Greyscale/400 #A4AAAC']}
                />
              ),
              ...options,
            }}
          />
        ))}
      </Tabs>
    </View>
  )
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TabsPropsBase = Exclude<NonNullable<ComponentProps<typeof Tabs>>, (...args: any[]) => any>
export type TabsProps = Exclude<TabsPropsBase, 'screenOptions'> & Pick<TabsPropsBase, 'tabBar'>
